export default {
	label: null,
	label2: null,
	label3: null,
	id: null,
	id2: null,
	id3: null,
	__typename: "BreadcrumbsMeta"
};



// WEBPACK FOOTER //
// ./src/graphql/breadcrumbsMeta/defaultCache.js